/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Select_File_LabelInputs */



/**
* | output |
* | --- |
* | "Select Marker File" |
*
* @param {Marker_Import_Select_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_select_file_label = /** @type {((inputs?: Marker_Import_Select_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Select_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner le fichier de marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markerdatei auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona file marcatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите файл маркера")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar archivo de marcador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择标记文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーファイルを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर फ़ाइल का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionar arquivo marcador")
	return /** @type {LocalizedString} */ ("Select Marker File")
});